import React, { useState } from "react";
import styled from "styled-components";
import Modal1st2911 from "../../components/modals/Modal1st2911";
import { Button1st2911 } from "../../components/buttons/Button1st2911";
import { FiEdit } from "react-icons/fi";
import { FormInput } from "../../components/inputs/FormInput";
import Dropdown1st2911 from "../../components/dropdown1st2911";
import { selectStyle } from "../../Styles/styledComponents/ReactSelect";

// function MyVerticallyCenteredModal(props) {
//   const { show } = props;
//   const [showEdit, setShowEdit] = useState(show);

//   return (
//     <div>
//       {/* <button
//         className="btn btn-info btn-sm"
//         onClick={() => setShowSuccess(true)}
//       >
//         Open Modal 1
//       </button> */}

//       <Modal1st2911
//         show={showEdit}
//         size="lg"
//         handleClose={() => {
//           setShowEdit(false);
//         }}
//         handleShow={() => setShowEdit(true)}
//         modalTitle="Email Registration"
//       >
//         New user is successfully registered!
//         <Button1st2911
//           data={{
//             onClick: "",
//             label: "Ok",
//           }}
//         />
//       </Modal1st2911>
//     </div>
//   );
// }

const EditModal = () => {
  const [formValue, setFormValue] = useState({
    email: "",
    phoneNumber: "",
    badgeNumber: "",
  });

  const [selectValue, setSelectValue] = useState("");
  const handleChangeSelect = (selected) => {
    // setRegisterSuccess("");
    console.log(selected.value);
    setSelectValue(selected);
    setFormValue({ ...formValue, userRole: selected.value });
  };
  // const AdminOptions = [
  //   { id: 1, label: "First Responders", value: "firstResponders" },
  // ];
  const superAdminOptions = [
    { id: 1, label: "First Responders", value: "firstResponders" },
    { id: 2, label: "Admin", value: "Admin" },
    { id: 3, label: "Super Admin", value: "superAdmin" },
  ];
  const [modalShow, setModalShow] = React.useState(false);
  console.log(modalShow);
  return (
    <>
      {/* <Button variant="primary" onClick={() => setModalShow(true)}>
        Launch vertically centered modal
      </Button> */}
      <FiEdit className="EditIcon" onClick={() => setModalShow(true)} />

      <Modal1st2911
        show={modalShow}
        size="lg"
        handleClose={() => {
          setModalShow(false);
        }}
        onHide={() => setModalShow(false)}
        handleShow={() => setModalShow(true)}
        modalTitle="Edit User Account"
      >
        <FormInput
          data={{
            name: "email",
            label: "Email Address",
            type: "email",
            onChange: "",
          }}
        />
        <FormInput
          data={{
            name: "phone number",
            label: "Phone Number",
            type: "phoneNumber",
            onChange: "",
          }}
        />
        <FormInput
          data={{
            name: "badge identification",
            label: "Badge or Identification Number",
            type: "badge",
            onChange: "",
          }}
        />
        <Dropdown1st2911
          data={{
            label: "Select User Role",
            placeholder: "Select...",
            options: superAdminOptions,
            customStyle: selectStyle,
            onchange: handleChangeSelect,
            // className: "DropdownStyle",
          }}
        />
        <ModalButtonDiv>
          <Button1st2911
            data={{
              onClick: "",
              label: "Edit",
            }}
          />
        </ModalButtonDiv>
      </Modal1st2911>
    </>
  );
};

export default EditModal;

const ModalButtonDiv = styled.div`
  width: 85%;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
